import React from 'react';

function VendorStats(props) {
   const { vendorStats } = props;

   return (
      <div className="vendors__dashboard-grid">
         <div className="vendors__summary-card">
            <div className="vendors__summary-title">Total Vendors</div>
            <div className="vendors__summary-value">{vendorStats.total}</div>
            <div className="vendors__summary-label">All vendor accounts</div>
         </div>

         <div className="vendors__summary-card active-card">
            <div className="vendors__summary-title">Active</div>
            <div className="vendors__summary-value">{vendorStats.active}</div>
            <div className="vendors__summary-label">Currently active</div>
         </div>

         <div className="vendors__summary-card inactive-card">
            <div className="vendors__summary-title">Inactive</div>
            <div className="vendors__summary-value">{vendorStats.inactive}</div>
            <div className="vendors__summary-label">Deactivated accounts</div>
         </div>
      </div>
   );
}

export default VendorStats;
